import client from './client.js';

// Envía una comanda. El backend es idempotente por client_uuid y responde
// `created:false` si ya la tenía — el POS usa eso para no reimprimir.
export const fireKitchenOrder = (payload) =>
  client.post('/kitchen/orders', payload).then((r) => r.data);

export const getKitchenOrders = (params) =>
  client.get('/kitchen/orders', { params }).then((r) => r.data);

export const setKitchenOrderStatus = (id, status) =>
  client.patch(`/kitchen/orders/${id}/status`, { status }).then((r) => r.data);

// Al cobrar una cuenta, lo que siga abierto en cocina se da por entregado
export const markTabServed = (tabId) =>
  client.post(`/kitchen/tabs/${encodeURIComponent(tabId)}/served`).then((r) => r.data);

// Cancelar con motivo. `wasted` decide si los insumos vuelven al almacén o si
// ya se gastaron: es la diferencia entre corregir un error de captura y
// registrar una merma.
export const cancelKitchenOrder = (id, { reason, note = null, wasted = false }) =>
  client.post(`/kitchen/orders/${id}/cancel`, { reason, note, wasted }).then((r) => r.data);
